import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { useMemo } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { isSSR } from '@atlaskit/editor-common/core-utils';
import { ToolbarSize } from '@atlaskit/editor-common/types';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { WidthObserver } from '@atlaskit/width-detector';
import { isFullPage } from '../../utils/is-full-page';
import { useElementWidth } from './hooks';
import { Toolbar } from './Toolbar';
import { toolbarSizeToWidth, widthToToolbarSize } from './toolbar-size';
var toolbar = css({
  width: '100%',
  position: 'relative'
});
export var ToolbarWithSizeDetector = function ToolbarWithSizeDetector(props) {
  var ref = React.useRef(null);
  var _React$useState = React.useState(undefined),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    width = _React$useState2[0],
    setWidth = _React$useState2[1];
  var elementWidth = useElementWidth(ref, {
    skip: typeof width !== 'undefined'
  });
  var defaultToolbarSize = isSSR() && isFullPage(props.appearance) ? ToolbarSize.XXL : undefined;
  var toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize :
  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  widthToToolbarSize(width || elementWidth, props.appearance);
  var minWidthValue = useMemo(function () {
    if (props.hasMinWidth) {
      var toolbarWidth = isFullPage(props.appearance) && props.twoLineEditorToolbar ? ToolbarSize.S : ToolbarSize.M;
      return "".concat(toolbarSizeToWidth(toolbarWidth, props.appearance), "px");
    } else {
      var isPreviewPanelResponsivenessEnabled = editorExperiment('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
      });
      return isPreviewPanelResponsivenessEnabled ? 'fit-content' : '254px';
    }
  }, [props.appearance, props.hasMinWidth, props.twoLineEditorToolbar]);
  return jsx("div", {
    css: toolbar,
    style: {
      minWidth: minWidthValue
    }
  }, jsx(WidthObserver, {
    setWidth: setWidth
  }), props.editorView && toolbarSize ? jsx(Toolbar, {
    toolbarSize: toolbarSize,
    items: props.items,
    editorView: props.editorView,
    editorActions: props.editorActions,
    eventDispatcher: props.eventDispatcher,
    providerFactory: props.providerFactory,
    appearance: props.appearance,
    popupsMountPoint: props.popupsMountPoint,
    popupsBoundariesElement: props.popupsBoundariesElement,
    popupsScrollableElement: props.popupsScrollableElement,
    disabled: props.disabled,
    dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
    containerElement: props.containerElement,
    hasMinWidth: props.hasMinWidth,
    twoLineEditorToolbar: props.twoLineEditorToolbar
  }) : jsx("div", {
    ref: ref
  }));
};